import { FinancialInstitutionLender } from '@models/lender';
import { Action } from 'src/app/shared/state/utils/models';

export enum DropdownSelect {
	CREATE = 'create',
	SELECT_INSTITUTION = 'selectInstitution',
	SELECT_BRANCH = 'selectBranch',
}

export interface onSelectInstitution {
	financialInstitution: FinancialInstitutionLender;
	action: Action;
}
